module.exports = __webpack_public_path__ + "static/media/David_Fesliyan_Deep_Meditation.ea3ebc60.mp3";